import styled, { keyframes } from "styled-components";
import { useHistory } from "react-router-dom";

export default function PageNotFound() {
  const navigate = useHistory();

  return (
    <Page>
      <Content>
        <BigNumber>404</BigNumber>
        <GoldBar />
        <Title>Page introuvable</Title>
        <Sub>
          La page que vous cherchez n'existe pas ou a été déplacée.
        </Sub>
        <Actions>
          <PrimaryBtn onClick={() => navigate.push("/")}>
            Retour à l'accueil
          </PrimaryBtn>
          <OutlineBtn
            onClick={() => {
              const el = document.getElementById("footer");
              if (el) el.scrollIntoView({ behavior: "smooth" });
              navigate.push("/#footer");
            }}
          >
            Nous contacter
          </OutlineBtn>
        </Actions>
      </Content>
    </Page>
  );
}

/* ─── Keyframes ─── */
const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(30px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-10px); }
`;

/* ─── Styled Components ─── */

const Page = styled.div`
  min-height: 100dvh;
  background: var(--bg-base);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.25rem;
  padding-top: 72px;
  text-align: center;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  animation: ${fadeUp} 0.7s ease both;
`;

const BigNumber = styled.h1`
  font-family: var(--font-heading);
  font-size: clamp(7rem, 20vw, 14rem);
  color: var(--bg-card);
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.04em;
  position: relative;
  animation: ${float} 5s ease-in-out infinite;

  /* Gold outline effect */
  -webkit-text-stroke: 2px var(--border);
`;

const GoldBar = styled.div`
  width: 60px;
  height: 2px;
  background: linear-gradient(to right, transparent, var(--primary), transparent);
`;

const Title = styled.h2`
  font-family: var(--font-heading);
  font-size: clamp(1.5rem, 4vw, 2.2rem);
  color: var(--cream);
  font-weight: 500;
`;

const Sub = styled.p`
  font-size: clamp(0.9rem, 2vw, 1rem);
  color: var(--cream-muted);
  max-width: 400px;
  line-height: 1.7;
  margin-bottom: 0.5rem;
`;

const Actions = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 0.5rem;
`;

const PrimaryBtn = styled.button`
  padding: 0.85rem 2.25rem;
  background: linear-gradient(135deg, var(--primary), var(--primary-dark));
  color: var(--bg-base);
  font-family: var(--font-body);
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: var(--transition);

  &:hover {
    background: linear-gradient(135deg, var(--primary-light), var(--primary));
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(200, 151, 62, 0.3);
  }
`;

const OutlineBtn = styled.button`
  padding: 0.85rem 2.25rem;
  background: transparent;
  color: var(--cream-dim);
  font-family: var(--font-body);
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: var(--transition);

  &:hover {
    border-color: var(--primary);
    color: var(--primary);
    background: var(--primary-glow);
  }
`;
